
function autoDimensions ({width, height, sourceWidth, sourceHeight, preventConflict}) {
    if (typeof width === "undefined" && typeof height === "undefined") {
        width  = sourceWidth
        height = sourceHeight
    } else if (typeof width  === "undefined") {
        width  = autoWidth({height, sourceWidth, sourceHeight})
    } else if (typeof height === "undefined") {
        height = autoHeight({width, sourceWidth, sourceHeight})
    } else if (preventConflict) {
        checkRatioConflict({width, height, sourceWidth, sourceHeight})
    }

    return {width, height}
}


function autoWidth ({height, sourceWidth, sourceHeight}) {
    if (sourceHeight === 0) {
        return 0
    }
    return sourceWidth * height / sourceHeight
}


function autoHeight ({width, sourceWidth, sourceHeight}) {
    if (sourceWidth === 0) {
        return 0
    }
    return sourceHeight * width / sourceWidth
}


function checkRatioConflict ({width, height, sourceWidth, sourceHeight}) {
    const sourceRatio = sourceWidth / sourceHeight
    const outputRatio = width / height
    if (Math.abs(sourceRatio - outputRatio) > 0.00001) { //eslint-disable-line no-magic-numbers
        throw new Error("Mismatched dimensions")
    }
}


export default autoDimensions

